import React, { useEffect, useRef, useState } from "react";
import { CalendarBlock } from "../types";
import "../pages/PurchaseOrders.css";

interface Props {
  /** startAt / endAt yerel "YYYY-AA-GGTSS:DD" biçiminde (datetime-local). Çevrim sayfada yapılır. */
  initial: CalendarBlock;
  busy: boolean;
  onClose: () => void;
  onSave: (draft: CalendarBlock) => void;
}

const I = {
  close: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6 6 18" /></svg>,
};

/** Meşguliyet ekle — takvimde randevuya kapalı aralık. Esc kapatır, Ctrl+Enter kaydeder. */
const CalendarBlockModal: React.FC<Props> = ({ initial, busy, onClose, onSave }) => {
  const [draft, setDraft] = useState<CalendarBlock>(initial);
  const [opener] = useState(() => document.activeElement as HTMLElement | null);
  const firstRef = useRef<HTMLInputElement | null>(null);
  const valid = !!draft.title.trim() && !!draft.startAt && !!draft.endAt && draft.endAt > draft.startAt;

  const submit = (e?: React.FormEvent) => {
    e?.preventDefault();
    if (busy || !valid) return;
    onSave(draft);
  };

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) { e.stopPropagation(); onClose(); }
      else if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) { e.preventDefault(); submit(); }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, busy, draft]);

  useEffect(() => () => { if (opener && opener.isConnected) opener.focus?.({ preventScroll: true }); }, [opener]);
  useEffect(() => { firstRef.current?.focus(); }, []);

  return (
    <div className="po-overlay center top" onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onClose(); }}>
      <form className="po-modal" role="dialog" aria-modal="true" aria-labelledby="ap-block-title" onSubmit={submit}>
        <div className="po-modal-head">
          <div><span className="po-kicker">Takvim</span><h3 id="ap-block-title">Meşguliyet ekle</h3></div>
          <button type="button" className="po-ib big" aria-label="Kapat" onClick={onClose} disabled={busy}>{I.close}</button>
        </div>
        <div className="po-modal-body">
          <p className="po-form-hint">Bu aralık randevuya kapanır. Dışarıdaki kişi yalnız saatin dolu olduğunu görür, başlığı görmez.</p>
          <label className="po-field">
            <span>Başlık<em>zorunlu</em></span>
            <input ref={firstRef} value={draft.title} maxLength={120} placeholder="Fabrika turu" onChange={(e) => setDraft({ ...draft, title: e.target.value })} />
          </label>
          <div className="po-grid2">
            <label className="po-field">
              <span>Başlangıç</span>
              <input type="datetime-local" value={draft.startAt.slice(0, 16)} onChange={(e) => setDraft({ ...draft, startAt: e.target.value })} />
            </label>
            <label className="po-field">
              <span>Bitiş</span>
              <input type="datetime-local" value={draft.endAt.slice(0, 16)} onChange={(e) => setDraft({ ...draft, endAt: e.target.value })} />
              {draft.startAt && draft.endAt && draft.endAt <= draft.startAt && <span className="po-fielderr">Bitiş, başlangıçtan sonra olmalı.</span>}
            </label>
          </div>
        </div>
        <div className="po-modal-foot">
          <button type="button" className="po-btn" onClick={onClose} disabled={busy}>Vazgeç</button>
          <button type="submit" className="po-btn primary" disabled={busy || !valid}>{busy ? "Ekleniyor" : "Ekle"}</button>
        </div>
      </form>
    </div>
  );
};

export default CalendarBlockModal;
